(function () {

    function initResultados(section) {

        if (!section || section.dataset.n26Initialized === 'true') {
            return;
        }

        const dataElement = section.querySelector('[data-n26-results-data]');

        if (!dataElement) {
            return;
        }

        let data;

        try {
            data = JSON.parse(dataElement.textContent);
        } catch (error) {
            console.error('NutriADN 2026: error leyendo datos de resultados.', error);
            return;
        }

        const tabs = section.querySelectorAll('[data-n26-tab]');
        const images = section.querySelectorAll('[data-n26-image]');

        const title = section.querySelector('[data-n26-title]');
        const body = section.querySelector('[data-n26-body]');

        const chipTitle = section.querySelector('[data-n26-chip-title]');
        const chipSubtitle = section.querySelector('[data-n26-chip-subtitle]');
        const chipValue = section.querySelector('[data-n26-chip-value]');
        const chipProgress = section.querySelector('[data-n26-chip-progress]');


        function activate(index) {

            const item = data[index];

            if (!item) {
                return;
            }


            /* -----------------------------
               TAB
            ----------------------------- */

            tabs.forEach((tab, tabIndex) => {

                const active = tabIndex === index;

                tab.classList.toggle('is-active', active);

                tab.setAttribute(
                    'aria-selected',
                    active ? 'true' : 'false'
                );

            });


            /* -----------------------------
               IMAGEN
            ----------------------------- */

            images.forEach((image, imageIndex) => {

                image.classList.toggle(
                    'is-active',
                    imageIndex === index
                );

            });


            /* -----------------------------
               TITULO
            ----------------------------- */

            if (title) {

                title.innerHTML = '';

                const before = document.createTextNode(
                    item.before + ' '
                );

                title.appendChild(before);


                if (item.accent) {

                    const em = document.createElement('em');

                    em.textContent = item.accent;

                    title.appendChild(em);

                    title.appendChild(
                        document.createTextNode(' ')
                    );

                }


                title.appendChild(
                    document.createTextNode(item.after)
                );

            }


            /* -----------------------------
               BODY
            ----------------------------- */

            if (body) {

                const paragraph = document.createElement('p');

                paragraph.textContent = item.description;

                body.innerHTML = '';

                body.appendChild(paragraph);

            }


            /* -----------------------------
               CHIP
            ----------------------------- */

            if (chipTitle) {
                chipTitle.textContent = item.chipTitle;
            }

            if (chipSubtitle) {
                chipSubtitle.textContent = item.chipSubtitle;
            }

            if (chipValue) {
                chipValue.textContent = item.chipValue;
            }

            if (chipProgress) {

                chipProgress.style.width =
                    item.chipProgress + '%';

            }

        }


        tabs.forEach((tab) => {

            tab.addEventListener('click', function () {

                const index = Number(
                    this.dataset.n26Tab
                );

                activate(index);

            });

        });


        section.dataset.n26Initialized = 'true';

    }


    /* =====================================================
       CARGA NORMAL
    ===================================================== */

    function initAllResultados() {

        document
            .querySelectorAll('[data-n26-resultados]')
            .forEach(initResultados);

    }


    if (document.readyState === 'loading') {

        document.addEventListener(
            'DOMContentLoaded',
            initAllResultados
        );

    } else {

        initAllResultados();

    }


    /* =====================================================
       SHOPIFY THEME EDITOR
    ===================================================== */

    document.addEventListener(
        'shopify:section:load',
        function (event) {

            const section =
                event.target.querySelector('[data-n26-resultados]') ||
                (
                    event.target.matches &&
                        event.target.matches('[data-n26-resultados]')
                        ? event.target
                        : null
                );

            if (section) {
                initResultados(section);
            }

        }
    );


    /* =========================================================
       TESTIMONIOS
    ========================================================= */

    function initTestimonials(section) {

        if (!section || section.dataset.n26TestimonialsInitialized === 'true') {
            return;
        }

        const track = section.querySelector('[data-n26-testimonials-track]');
        const cards = section.querySelectorAll('.n26-testimonios__card');

        const prev = section.querySelector('[data-n26-testimonials-prev]');
        const next = section.querySelector('[data-n26-testimonials-next]');

        const currentEl = section.querySelector('[data-n26-testimonials-current]');
        const totalEl = section.querySelector('[data-n26-testimonials-total]');

        if (!track || !cards.length) {
            return;
        }


        let page = 0;


        function getPerPage() {

            return window.matchMedia('(max-width: 1100px)').matches
                ? 1
                : 3;

        }


        function render() {

            const perPage = getPerPage();

            const totalPages =
                Math.max(
                    1,
                    Math.ceil(cards.length / perPage)
                );

            if (page >= totalPages) {
                page = 0;
            }

            if (page < 0) {
                page = totalPages - 1;
            }


            const firstCard = cards[0];

            const gap = 16;

            const cardWidth =
                firstCard.getBoundingClientRect().width;

            const offset =
                page *
                perPage *
                (cardWidth + gap);


            track.style.transform =
                `translateX(-${offset}px)`;


            if (currentEl) {
                currentEl.textContent = page + 1;
            }

            if (totalEl) {
                totalEl.textContent = totalPages;
            }

        }


        if (prev) {

            prev.addEventListener('click', function () {

                page--;

                render();

            });

        }


        if (next) {

            next.addEventListener('click', function () {

                page++;

                render();

            });

        }


        let resizeTimer;

        window.addEventListener('resize', function () {

            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function () {

                page = 0;

                render();

            }, 150);

        });


        render();

        section.dataset.n26TestimonialsInitialized = 'true';

    }


    /* Inicializar testimonios */

    document
        .querySelectorAll('[data-n26-testimonials]')
        .forEach(initTestimonials);


    /* Theme Editor */

    document.addEventListener(
        'shopify:section:load',
        function (event) {

            const testimonialSection =
                event.target.querySelector('[data-n26-testimonials]') ||
                (
                    event.target.matches &&
                        event.target.matches('[data-n26-testimonials]')
                        ? event.target
                        : null
                );

            if (testimonialSection) {
                initTestimonials(testimonialSection);
            }

        }
    );

})();